"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var subjectAreas_1 = require("./subjectAreas");
var getSubjectByTitle_1 = require("./getSubjectByTitle");
exports.subjectAreasMap = {
    foreignLanguage: getSubjectByTitle_1.getSubjectByTitle(subjectAreas_1.default, "FOREIGN LANGUAGE"),
    rotc: getSubjectByTitle_1.getSubjectByTitle(subjectAreas_1.default, "FOREIGN LANGUAGE")
};
//# sourceMappingURL=subjectAreaMap.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/subjects_data/subjectAreaMap.js
// module id = 456
// module chunks = 22